import React from 'react';
import VehicleIcon from './VehicleIcons';

// Traveler Mode only: the things he loves drift across the parchment — Nara
// deer, the Horyu-ji pagoda, mountains, tuk-tuks, ships, backpacks... Each
// floater has its own size, speed, and heading (angle in degrees; 0 = east,
// 180 = west, positive tilts drift downward). Pure CSS animation; a static
// scatter under prefers-reduced-motion.
const FLOATERS = [
  { type: 'deer', top: 6, left: 15, size: 78, dur: 96, delay: -12, angle: 8 },
  { type: 'tuktuk', top: 14, left: 70, size: 92, dur: 70, delay: -40, angle: 188 },
  { type: 'mountain', top: 22, left: 40, size: 118, dur: 128, delay: -70, angle: -6 },
  { type: 'ship', top: 30, left: 85, size: 80, dur: 102, delay: -25, angle: 170 },
  { type: 'bicycle', top: 38, left: 25, size: 66, dur: 78, delay: -58, angle: 14 },
  { type: 'pagoda', top: 46, left: 60, size: 100, dur: 138, delay: -95, angle: 184 },
  { type: 'backpack', top: 54, left: 10, size: 58, dur: 88, delay: -8, angle: -12 },
  { type: 'cub', top: 62, left: 78, size: 86, dur: 72, delay: -33, angle: 196 },
  { type: 'tent', top: 70, left: 35, size: 72, dur: 112, delay: -80, angle: 6 },
  { type: 'compass', top: 78, left: 88, size: 54, dur: 98, delay: -50, angle: 162 },
  { type: 'mountain', top: 86, left: 55, size: 96, dur: 122, delay: -20, angle: -8 },
  { type: 'deer', top: 92, left: 20, size: 52, dur: 86, delay: -66, angle: 12 },
  { type: 'train', top: 10, left: 45, size: 70, dur: 92, delay: -47, angle: 176 },
  { type: 'thumb', top: 26, left: 5, size: 48, dur: 74, delay: -18, angle: 22 },
  { type: 'motorbike', top: 42, left: 92, size: 74, dur: 84, delay: -61, angle: 202 },
  { type: 'ship', top: 58, left: 48, size: 62, dur: 118, delay: -37, angle: -16 },
  { type: 'bicycle', top: 74, left: 68, size: 88, dur: 94, delay: -74, angle: 168 },
  { type: 'campervan', top: 82, left: 8, size: 82, dur: 80, delay: -29, angle: 10 },
  { type: 'tent', top: 18, left: 30, size: 50, dur: 106, delay: -88, angle: -20 },
  { type: 'pagoda', top: 66, left: 15, size: 64, dur: 126, delay: -55, angle: 178 },
];

function TravelerBackdrop() {
  return (
    <div className="traveler-backdrop" aria-hidden="true">
      {FLOATERS.map((item, index) => (
        <span
          key={`${item.type}-${index}`}
          className="traveler-backdrop__item"
          style={{
            '--float-top': `${item.top}%`,
            '--float-left': `${item.left}%`,
            '--float-size': `${item.size}px`,
            '--float-dur': `${item.dur}s`,
            '--float-delay': `${item.delay}s`,
            '--float-angle': `${item.angle}deg`,
          }}
        >
          <span className="traveler-backdrop__mover">
            <VehicleIcon type={item.type} strokeWidth={1.1} />
          </span>
        </span>
      ))}
    </div>
  );
}

export default TravelerBackdrop;
